import React from 'react';
import MainLayout from '../utilities/layouts/MainLayout';
import { makeStyles } from '@material-ui/core';
import { ReactComponent as AccountPaused } from '../../resources/images/account-paused.svg';
import { PAUSED_MESSAGE_BODY } from '../../resources/messages.json';
import { FullScreenPageNoButton } from '../../components/FullScreenButtonPage';
import { styleBreakMobile } from '../utilities/layouts/Globals';
import { getValue } from '../../styles/stylesSelector';

const useStyles = makeStyles(theme => ({
    box: {
        paddingTop: theme.spacing(8),
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    pausedLayoutContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        marginBottom: theme.spacing(2),
        fontSize: theme.spacing(5),
        textAlign: 'left',
        fontWeight: 700,
        lineHeight: 1.3,
        letterSpacing: '0.3px',
        maxWidth: '250px',
        [styleBreakMobile(theme)]: {
            textAlign: 'center',
            maxWidth: '327px',
            fontSize: theme.spacing(4) - 2,
        },
    },
    message: {
        textAlign: 'left',
        letterSpacing: '0.16px',
    },
    titleEmp: {
        color: theme.palette.primary.main,
    },
}));

function TitleText() {
    const classes = useStyles();
    return (<h2 data-cy="text_pause_title" className={classes.title}>Virtual <span className={classes.titleEmp}>Follow-up</span> Paused</h2>);
}

export default function PausedHomePage() {
    const message = PAUSED_MESSAGE_BODY;
    return (
        <MainLayout>
            <FullScreenPageNoButton
                Icon={AccountPaused}
                SubtitleText={TitleText}
                bodyText={message}
                showButton={false}
                showShadow={getValue({
                    ned: false,
                    watchman: true
                })}
                bodyTestDataAttr="text_pause_body"
                iconTextDataAttr="icon_pause"
            />
        </MainLayout>
    );
}
